import { Redirect, Switch } from 'react-router-dom';
import { v as bvVar } from 'bv';

import {
  AuthenticatedRoute,
  UnauthenticatedRoute,
  Route,
  ComponentFlipper,
} from '../shared';

import {
  TwoFAPreferencesRoutes,
  Cashout,
  Betslip,
  ReferAFriend,
} from './components';

import {
  Settings,
  UserInbox,
  AccountOverview,
  SOWCollection,
  CashierActions,
  ContactUs,
  RequestCallback,
  AccountHistory,
  PasswordChange,
  PasswordReset,
  Registration,
  VerificationZone,
  PersonalDetails,
  SaferGamblingQuestionnaire,
  SaferGamblingPortal,
  TwoFACode,
  TwoFAVerifyPassword,
  Login,
  AsiaCashier,
  EmailVerification,
  QuickDeposit,
  GreyHoundsTimeTable,
  SaferGamblingLanding,
  MyTransactions,
  Search,
  KycRefresh,
  СasinoAllCategoriesPage,
} from './lazy_components';

const ModalRoutesView = () => (
  <Switch>
    <Route path="/preferences/edit">
      <Settings />
    </Route>
    <AuthenticatedRoute path="/customer_inbox" feature="customer_inbox">
      <UserInbox />
    </AuthenticatedRoute>
    <AuthenticatedRoute path={['/account', '/bv_cashier/overview']} exact>
      <AccountOverview />
    </AuthenticatedRoute>
    <AuthenticatedRoute path="/refer_a_friend">
      <ReferAFriend />
    </AuthenticatedRoute>
    <AuthenticatedRoute path="/account/verify/sow_collection">
      <SOWCollection />
    </AuthenticatedRoute>
    <AuthenticatedRoute
      path={['/bv_cashier/withdraw/pending', '/bv_cashier/payments']}
    >
      <CashierActions />
    </AuthenticatedRoute>
    <AuthenticatedRoute path={['/bv_cashier/deposit', '/bv_cashier/withdraw']}>
      <ComponentFlipper
        feature="asia_cashier"
        enabledComponent={<AsiaCashier />}
        disabledComponent={<CashierActions />}
      />
    </AuthenticatedRoute>
    <AuthenticatedRoute path="/bv_cashier/help" feature="asia_cashier">
      <AsiaCashier />
    </AuthenticatedRoute>
    <Route path="/pages/contact-us">
      <ContactUs />
    </Route>
    <Route path="/pages/request-callback">
      <RequestCallback />
    </Route>
    <AuthenticatedRoute path="/bv_cashier/history/:type?">
      <AccountHistory />
    </AuthenticatedRoute>
    <AuthenticatedRoute path="/bv_cashier/lottery/:type?" feature="lottoland">
      <AccountHistory />
    </AuthenticatedRoute>
    <AuthenticatedRoute path="/account/password_change">
      <PasswordChange />
    </AuthenticatedRoute>
    <UnauthenticatedRoute
      path={[
        '/account/password_reset',
        '/account/code_reset',
        '/:tab/account/reset_password',
      ]}
    >
      <PasswordReset />
    </UnauthenticatedRoute>
    <UnauthenticatedRoute path="/account/new">
      <Registration />
    </UnauthenticatedRoute>
    <Route path="/account/offers">
      <Registration kind="bonus_selection" />
    </Route>
    <AuthenticatedRoute path="/account/verification_zone">
      <VerificationZone />
    </AuthenticatedRoute>
    <AuthenticatedRoute path="/personal_details">
      <PersonalDetails />
    </AuthenticatedRoute>
    <AuthenticatedRoute path="/account/verify/refresh">
      <KycRefresh />
    </AuthenticatedRoute>
    <AuthenticatedRoute path="/safer_gambling/questionnaire/landing">
      <SaferGamblingLanding />
    </AuthenticatedRoute>
    {bvVar('showSaferGamblingQuestionnaire') && (
      <AuthenticatedRoute path="/safer_gambling/questionnaire">
        <SaferGamblingQuestionnaire />
      </AuthenticatedRoute>
    )}
    <Route path="/safer_gambling/portal">
      <SaferGamblingPortal />
    </Route>
    <Route path="/search">
      <Search />
    </Route>
    <UnauthenticatedRoute path="/login">
      <Login />
    </UnauthenticatedRoute>
    <UnauthenticatedRoute path="/twofactorauth/login">
      <TwoFACode login />
    </UnauthenticatedRoute>
    <Route path="/preferences/verify_password_twofactor">
      <TwoFAVerifyPassword />
    </Route>
    <AuthenticatedRoute path="/quick_deposit/:amount?">
      <QuickDeposit />
    </AuthenticatedRoute>
    <Route path="/sports/1000/timetable/:day">
      <GreyHoundsTimeTable />
    </Route>
    <AuthenticatedRoute path="/preferences/twofactorauth">
      <TwoFAPreferencesRoutes />
    </AuthenticatedRoute>
    <AuthenticatedRoute path="/unsubscribe">
      <Redirect to="/preferences/edit" />
    </AuthenticatedRoute>
    <AuthenticatedRoute path="/email_verification" feature="email_verification">
      <EmailVerification />
    </AuthenticatedRoute>
    <AuthenticatedRoute path="/cashout" feature="cashout">
      <Cashout />
    </AuthenticatedRoute>
    <Route path="/betslip">
      <Betslip />
    </Route>
    <AuthenticatedRoute
      path="/my_transactions/:slug?"
      feature="my_transactions"
    >
      <MyTransactions />
    </AuthenticatedRoute>
    <Route path="/preferences/verify_password_twofactor">
      <TwoFAVerifyPassword />
    </Route>
    {bvVar('casinoLobbies').map(({ slug }) => (
      <Route path={`/${slug}/all-categories`}>
        <СasinoAllCategoriesPage />
      </Route>
    ))}
  </Switch>
);

export default ModalRoutesView;
